//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const radioGroup = ref(1)

    return { radioGroup }
  },
}
